define('utils/accordion', [
    'jquery',
    'underscore',
    'velocity',
    'velocity.ui'
],  function ($, _, Velocity, VelocityUi) {
    'use strict';

    console.log('%cfile: accordion.js', 'color: #C2ECFF');

    var accordion = function accordion(){
        console.log('%ctrace: accordion', 'color: #ccc');

        var el = '[data-accordion]',
            item = '[data-accordion-item]',
            activeItem = '[data-accordion-item].active',
            title = '[data-accordion-item-title]',
            content = '[data-accordion-item-content]';

        var $el = $(el);

        if($el.length <= 0){
            console.warn('%ctrace: accordion: not found dom elements', 'color: #ccc');
            return false;
        }

        $el.each(function(i, el){
            initialize($(el));
        });

        function initialize($el){

            if($el.find(activeItem).length <= 0){
                $el.find(item).eq(0).addClass('active');
            }

            var $item = $el.find(item);
            var $title = $el.find(title);
            var $content = $el.find(content);

            var $activeItem;
            var $activeContent;

            var $currentItem;
            var $currentContent;

            var isAnimate = false;
            var duration = 150;

            $title.off('click').on('click', function(){
                var index = $title.index($(this));

                $activeItem = $el.find(activeItem);
                $activeContent = $activeItem.find(content);

                $currentItem = $item.eq(index);
                $currentContent = $currentItem.find(content);

                if($currentItem.is('.active')){
                    hide(index);
                }else{
                    show(index);
                }
            });

            function show(index){
                if(isAnimate){
                    return false;
                }

                isAnimate = true;

                if($activeItem.length > 0){
                    $activeContent.velocity('stop').velocity('slideUp', {
                        duration: duration,
                        delay: 0,
                        stagger: 0,
                        mobileHA: true,
                        begin: function(){

                        },
                        complete: function(){
                            $activeItem.removeClass('active');
                        }
                    });
                }

                $currentContent.velocity('stop').velocity('slideDown', {
                    duration: duration,
                    delay: 0,
                    stagger: 0,
                    mobileHA: true,
                    begin: function(){
                        $el.css('height', getElHeight());
                    },
                    complete: function(){
                        $currentItem.addClass('active');
                        $el.velocity({'height': getElHeight()}, {duration: duration * 2});

                        isAnimate = false;
                    }
                });
            }

            function hide(index){
                if(isAnimate){
                    return false;
                }

                isAnimate = true;

                $currentContent.velocity('stop').velocity('slideUp', {
                    duration: duration,
                    delay: 0,
                    stagger: 0,
                    mobileHA: true,
                    begin: function(){
                        $el.css('height', getElHeight());
                    },
                    complete: function(){
                        $currentItem.removeClass('active');
                        $el.velocity({'height': getElHeight()}, {duration: duration * 2});

                        isAnimate = false;
                    }
                });
            }

            function getElHeight(){
                var h = 0;
                $el.find('> *').each(function(i, el){
                    h += $(el).outerHeight(true);
                });

                return h;
            }
        }
    };

    return accordion;
});
